import React, { useEffect } from "react";
import { Form, Col, Row, Button, Select, Collapse, Input } from "antd";
import { CloseOutlined, SearchOutlined } from "@ant-design/icons";
import { odata } from "./Helper"; // Helper'ın içinde 'eq' fonksiyonu olduğunu varsayıyorum.

const MaterialCategoryTableFilter = (props) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (props.data) {
      form.setFieldsValue(props.data);
    }
  }, [props.data]);

  const onFinish = (values) => {
    let query = "";
    const conditions = [];

    // 1. İsim Filtresi
    if (values.name) {
      conditions.push(odata.contains("name", values.name));
    }

    // 2. Kategori Tipi (Seviye) Filtresi - GÜNCELLENDİ
    // Backend'de eklediğimiz 'Level' property'sini kullanıyoruz.
    if (values.level) {
        // values.level string gelebilir, OData için int lazım, o yüzden dönüşüm gerekebilir
        // veya direk string gönderiyorsan "Level eq 1" şeklinde.
        conditions.push(`Level eq ${values.level}`);
    }

    if (conditions.length !== 0) {
      query = "&$filter=" + conditions.join(" and ");
    }

    if (props.onFinishFilter) props.onFinishFilter(query);
  };

  const clearFilter = () => {
    form.resetFields();
    if (props.onClearFilter) {
      props.onClearFilter();
    }
  };

  return (
    <Row id="filterArea" style={{ ...props.style }}>
      <Col span={24}>
        <Collapse>
          <Collapse.Panel header="Filtreleme için tıklayınız.">
            <Form
              name="filter"
              form={form}
              initialValues={{ remember: true }}
              layout="vertical"
              onFinish={onFinish}
            >
              <Row style={{ flexDirection: "row" }} gutter={16}>
                {/* İsim Arama */}
                <Col xs={24} md={12} lg={6}>
                  <Form.Item label={"Kategori Adı :"} name="name">
                    <Input placeholder="Kategori adı ara..." />
                  </Form.Item>
                </Col>

                {/* YENİ ALAN: Seviye Bazlı Seçim */}
                <Col xs={24} md={12} lg={6}>
                  <Form.Item label={"Kategori Seviyesi :"} name="level">
                    <Select allowClear placeholder="Seçiniz">
                      <Select.Option value={1}>
                        1. Seviye (Kategoriler)
                      </Select.Option>
                      <Select.Option value={2}>
                        2. Seviye (Ana Kategoriler)
                      </Select.Option>
                      <Select.Option value={3}>
                        3. Seviye (Alt Kategoriler)
                      </Select.Option>
                    </Select>
                  </Form.Item>
                </Col>
              </Row>

              <Row style={{ flexDirection: "row" }}>
                <Col span={24} style={{ textAlign: "right" }}>
                  <Button
                    danger
                    size="small"
                    icon={<CloseOutlined />}
                    onClick={() => clearFilter()}
                    style={{ marginRight: 8 }}
                  >
                    Sıfırla
                  </Button>
                  <Button
                    type="primary"
                    size="small"
                    icon={<SearchOutlined />}
                    style={{
                      color: "#fff",
                      borderColor: "#40a9ff",
                      backgroundColor: "#40a9ff",
                    }}
                    htmlType="submit"
                  >
                    Filtrele
                  </Button>
                </Col>
              </Row>
            </Form>
          </Collapse.Panel>
        </Collapse>
      </Col>
    </Row>
  );
};

export default MaterialCategoryTableFilter;